import React from 'react';
import './Home.css';
import Header from '../header/Header';
import Card from '../card/Card';

const Home = () => {
  return (
    <>
    <Header />
    <Card />
    </>
  )
}

export default Home;